import { UIField } from "../../../models/UIField";

export const EditboxField = ({ model, style }: { model: UIField; style?: string }) => {
  const s = model.readonly ? "addProductReadonlyField" : "addProductField";

  return <input className={`${s} ${style}`} disabled={model.disabled} readOnly={model.readonly} value={model.value} type="text" onChange={(e) => model.setValue(e.currentTarget.value)} />;
};
